const CONSENT_COOKIE = "cookie_consent_qrypto";
const CONSENT_MAX_AGE = 60 * 60 * 24 * 180;

export const getConsent = () => {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(CONSENT_COOKIE + "="));

  if (!match) return null;

  try {
    return JSON.parse(decodeURIComponent(match.split("=")[1]));
  } catch {
    return null;
  }
};

export const setConsent = (consent) => {
  document.cookie = `${CONSENT_COOKIE}=${encodeURIComponent(
    JSON.stringify(consent)
  )}; path=/; max-age=${CONSENT_MAX_AGE}; SameSite=Lax`;

  window.dispatchEvent(
    new CustomEvent("cookie-consent-changed", {
      detail: consent,
    })
  );
};

export const hasConsent = (category) => {
  const consent = getConsent();
  return !!consent?.[category];
};
